module.exports = __webpack_public_path__ + "static/media/ai-page-hero-3.c8e63c63.png";